import React from 'react';
import DelaysBreakdown, { DelayReason } from './DelaysBreakdown';

interface PacuDelaysBreakdownProps {
  reasons: DelayReason[];
  /** Fixed chart height in px. When set, skips aspect-ratio sizing so wide panels stay short. */
  height?: number;
}

const PacuDelaysBreakdown = (props: PacuDelaysBreakdownProps) => {
  return <DelaysBreakdown reasons={props.reasons} height={props.height} />;
};

export default PacuDelaysBreakdown;
